package guide.kuki.app.engine

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * JSON structure for radial map grid data files
 * (radial_map_100min.json / radial_map_60min.json).
 */
@Serializable
data class RadialMapData(
    val sections: List<Int>,
    val radials: List<List<List<Double>>>,
)

/**
 * JSON structure for a single named location entry in names.json.
 */
@Serializable
data class NameEntry(
    val name: String = "",
    val meaning: String = "",
)

/**
 * Converts parsed [RadialMapData] into a [RadialMap] engine instance.
 */
fun RadialMapData.toRadialMap(): RadialMap {
    val radialArrays = radials.map { radial ->
        radial.map { pt -> doubleArrayOf(pt[0], pt[1]) }
    }
    return RadialMap(radialArrays, sections)
}

/**
 * Converts parsed name entries into the flat map expected by [RadialMap.loadAddresses].
 * Keys are like "a1", "ka2", "ngo1", etc. Values are the name strings.
 */
fun Map<String, NameEntry>.toAddressNames(): Map<String, String> {
    return mapValues { it.value.name }
}
